import script from "./AddProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./AddProduct.vue?vue&type=script&setup=true&lang=js"

import "./AddProduct.vue?vue&type=style&index=0&id=efc475aa&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efc475aa"]])

export default __exports__